/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteAdministrationOrganizationWebhook } from '../fn/webhooks/delete-administration-organization-webhook';
import { DeleteAdministrationOrganizationWebhook$Params } from '../fn/webhooks/delete-administration-organization-webhook';
import { getAdministrationOrganizationWebhooks } from '../fn/webhooks/get-administration-organization-webhooks';
import { GetAdministrationOrganizationWebhooks$Params } from '../fn/webhooks/get-administration-organization-webhooks';
import { postAdministrationOrganizationWebhook } from '../fn/webhooks/post-administration-organization-webhook';
import { PostAdministrationOrganizationWebhook$Params } from '../fn/webhooks/post-administration-organization-webhook';
import { rotateAdministrationOrganizationWebhook } from '../fn/webhooks/rotate-administration-organization-webhook';
import { RotateAdministrationOrganizationWebhook$Params } from '../fn/webhooks/rotate-administration-organization-webhook';
import { WebhookConfigurationsArray } from '../models/webhook-configurations-array';
import { WebhookCreatedResponse } from '../models/webhook-created-response';

@Injectable({ providedIn: 'root' })
export class WebhooksService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAdministrationOrganizationWebhooks()` */
  static readonly GetAdministrationOrganizationWebhooksPath = '/administration/organizations/{organizationKey}/webhooks';

  /**
   * Get all webhooks for the organization.
   *
   * Get all webhooks for the organization
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAdministrationOrganizationWebhooks()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAdministrationOrganizationWebhooks$Response(params: GetAdministrationOrganizationWebhooks$Params, context?: HttpContext): Observable<StrictHttpResponse<WebhookConfigurationsArray>> {
    return getAdministrationOrganizationWebhooks(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all webhooks for the organization.
   *
   * Get all webhooks for the organization
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAdministrationOrganizationWebhooks$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAdministrationOrganizationWebhooks(params: GetAdministrationOrganizationWebhooks$Params, context?: HttpContext): Observable<WebhookConfigurationsArray> {
    return this.getAdministrationOrganizationWebhooks$Response(params, context).pipe(
      map((r: StrictHttpResponse<WebhookConfigurationsArray>): WebhookConfigurationsArray => r.body)
    );
  }

  /** Path part for operation `postAdministrationOrganizationWebhook()` */
  static readonly PostAdministrationOrganizationWebhookPath = '/administration/organizations/{organizationKey}/webhooks';

  /**
   * Create a new webhook for the organization.
   *
   * Create a new webhook for the organization.
   * Currently only the webhook event type "reference_number_updated" is officially supported.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postAdministrationOrganizationWebhook()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postAdministrationOrganizationWebhook$Response(params: PostAdministrationOrganizationWebhook$Params, context?: HttpContext): Observable<StrictHttpResponse<WebhookCreatedResponse>> {
    return postAdministrationOrganizationWebhook(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a new webhook for the organization.
   *
   * Create a new webhook for the organization.
   * Currently only the webhook event type "reference_number_updated" is officially supported.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postAdministrationOrganizationWebhook$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postAdministrationOrganizationWebhook(params: PostAdministrationOrganizationWebhook$Params, context?: HttpContext): Observable<WebhookCreatedResponse> {
    return this.postAdministrationOrganizationWebhook$Response(params, context).pipe(
      map((r: StrictHttpResponse<WebhookCreatedResponse>): WebhookCreatedResponse => r.body)
    );
  }

  /** Path part for operation `rotateAdministrationOrganizationWebhook()` */
  static readonly RotateAdministrationOrganizationWebhookPath = '/administration/organizations/{organizationKey}/webhooks/{webhookKey}/rotate';

  /**
   * Rotate the secret of a webhook for the organization.
   *
   * Rotate the secret of a webhook for the organization. The old secret will no longer be valid.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rotateAdministrationOrganizationWebhook()` instead.
   *
   * This method doesn't expect any request body.
   */
  rotateAdministrationOrganizationWebhook$Response(params: RotateAdministrationOrganizationWebhook$Params, context?: HttpContext): Observable<StrictHttpResponse<WebhookCreatedResponse>> {
    return rotateAdministrationOrganizationWebhook(this.http, this.rootUrl, params, context);
  }

  /**
   * Rotate the secret of a webhook for the organization.
   *
   * Rotate the secret of a webhook for the organization. The old secret will no longer be valid.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rotateAdministrationOrganizationWebhook$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rotateAdministrationOrganizationWebhook(params: RotateAdministrationOrganizationWebhook$Params, context?: HttpContext): Observable<WebhookCreatedResponse> {
    return this.rotateAdministrationOrganizationWebhook$Response(params, context).pipe(
      map((r: StrictHttpResponse<WebhookCreatedResponse>): WebhookCreatedResponse => r.body)
    );
  }

  /** Path part for operation `deleteAdministrationOrganizationWebhook()` */
  static readonly DeleteAdministrationOrganizationWebhookPath = '/administration/organizations/{organizationKey}/webhooks/{webhookKey}';

  /**
   * Delete a webhook for the organization.
   *
   * Delete a webhook for the organization
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteAdministrationOrganizationWebhook()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAdministrationOrganizationWebhook$Response(params: DeleteAdministrationOrganizationWebhook$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteAdministrationOrganizationWebhook(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a webhook for the organization.
   *
   * Delete a webhook for the organization
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteAdministrationOrganizationWebhook$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAdministrationOrganizationWebhook(params: DeleteAdministrationOrganizationWebhook$Params, context?: HttpContext): Observable<void> {
    return this.deleteAdministrationOrganizationWebhook$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
